import { create } from "zustand"

type ReOrderSectionDialogState = {
  isOpen: boolean
}

type ReOrderSectionDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useReOrderSectionDialogV1 = create<
  ReOrderSectionDialogState & ReOrderSectionDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useReOrderSectionDialogV1
